module.exports = __webpack_public_path__ + "img/strawberry.bf483da6.png";